import { compile } from 'path-to-regexp';
import buildQueryString from 'shared/utils/buildQueryString';

export function createParametrizedUrl<Parameters extends object>(url: string) {
  return (parameters: Parameters) => {
    const compiled = compile<Parameters>(url)(parameters);
    return compiled;
  };
}

export function withQueryString<Query extends Record<string, any>>(url: string) {
  return (params?: Query) => {
    const queryString = buildQueryString(params);

    return queryString ? `${url}?${queryString}` : url;
  };
}

export function createParametrizedUrlWithQueryString<
  Parameters extends Record<string, any>,
  Query extends Record<string, any>
>(url: string) {
  return (parameters: Parameters, query?: Query) => {
    const compiled = compile<Parameters>(url)(parameters);
    return withQueryString<Query>(compiled)(query);
  };
}

export function createUrlWithBackUrl(url: string) {
  return (backUrl?: string) => (backUrl ? `${url}?returnUrl=${encodeURIComponent(backUrl)}` : url);
}
